module.exports = __webpack_public_path__ + "static/media/img1.c2b8068b.png";